import React, { useEffect, useState, useRef } from "react";
import "./AddEditDriver.scss";
import LinedTitle from "../../LinedTitle/LinedTitle";
import DynaInputFile from "../../../A13/DynaView/DynaInputFile";
import DynaDatePicker from "../../../A13/DynaView/DynaDatePicker";
import DynaInput from "../../../A13/DynaView/DynaInput";
import _axios from "../../../../httpService";
import { prefixUrl } from "../../../../utils/utilsData";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../../Loader";
import UtilsFunctions from "../../../../utils/UtilsFunctions";
import numeric from "../../../../utils/NumericFunction";
import { IranTagSVG } from "../../../A13/InsuranceFormCompomemts/InsuranceSVG/InsuranceSVG";
import { ArrowIcon, IranIcon } from "../../ChikaExportSvg/ChikaExportSvg";

const AddEditDriver = () => {
  const navigateTo = useNavigate();
  const myLocation = useLocation();

  // آیا در حالت ویرایش هستیم؟ + دریافت آی‌دی راننده + آیا از ثبت سفارش هدایت شده ایم؟
  const driverId = myLocation?.state?.id;
  const isEditMode = myLocation?.state?.mode === "edit";
  const isFromOrder = myLocation?.state?.fromOrder;

  // ==================== تاریخ امروز به شمسی ====================
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    calendar: "persian",
  };
  const todayDate = numeric.p2e(
    new Date().toLocaleDateString("fa-IR", options)
  );

  // ==================== وضعیت فرم اصلی ====================
  const [loading, setLoading] = useState(isEditMode);
  const [sendData, setSendData] = useState({
    driver_name: "",
    car_name: "",
    pelak: "",
    mobile: "",
    register_date: todayDate,
    car_pelak_image: "",
    driver_image: "",
  });

  // ==================== قطعات پلاک خودرو (۸ بخش جداگانه) ====================
  const [plateParts, setPlateParts] = useState({
    partOne: "",
    partTwo: "",
    partThree: "الف",
    partFour: "",
    partFive: "",
    partSix: "",
    partSeven: "",
    partEight: "",
  });

  // ==================== وضعیت دراپ‌دان حرف پلاک ====================
  const [openTag, setOpenTag] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [selectedTagIndex, setSelectedTagIndex] = useState(-1);

  const tagBoxRef = useRef(null);
  const tagInputRef = useRef(null);
  const tagListRef = useRef(null);

  // ==================== لیست حروف مجاز پلاک ایران ====================
  const tag = [
    { value: "الف", label: "الف" },
    { value: "ب", label: "ب" },
    { value: "پ", label: "پ" },
    { value: "ت", label: "ت" },
    { value: "ث", label: "ث" },
    { value: "ج", label: "ج" },
    { value: "د", label: "د" },
    { value: "ز", label: "ز" },
    { value: "س", label: "س" },
    { value: "ش", label: "ش" },
    { value: "ص", label: "ص" },
    { value: "ط", label: "ط" },
    { value: "ع", label: "ع" },
    { value: "ف", label: "ف" },
    { value: "ق", label: "ق" },
    { value: "ک", label: "ک" },
    { value: "گ", label: "گ" },
    { value: "ل", label: "ل" },
    { value: "م", label: "م" },
    { value: "ن", label: "ن" },
    { value: "و", label: "و" },
    { value: "ه", label: "ه" },
    { value: "ی", label: "ی" },
    { value: "ژ", label: "معلولین" },
    { value: "تشریفات", label: "تشریفات" },
    { value: "D", label: "D" },
    { value: "S", label: "S" },
  ];

  //==================== فیلتر کردن حروف بر اساس تایپ کاربر ====================
  const filteredTags = tag.filter(
    (item) => item.label.includes(filterText) || item.value.includes(filterText)
  );

  // ==================== دریافت اطلاعات راننده در حالت ویرایش ====================
  const getEditModeData = async () => {
    try {
      setLoading(true);
      const response = await _axios.get(
        prefixUrl() + "/cheeka/driver/index.php?id=" + driverId
      );

      if (response?.data?.status) {
        const data = response.data.data;

        // تجزیه پلاک و پر کردن قسمت‌های جداگانه
        if (data.pelak) {
          const parts = data.pelak.split("-");
          if (parts.length === 4) {
            const [p1, p2, p3, p4] = parts;
            setPlateParts({
              partOne: p1[0] || "",
              partTwo: p1[1] || "",
              partThree: p2 || "الف",
              partFour: p3[0] || "",
              partFive: p3[1] || "",
              partSix: p3[2] || "",
              partSeven: p4[0] || "",
              partEight: p4[1] || "",
            });
          }
        }

        setSendData(data);
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("خطا در ارتباط با سرور");
    } finally {
      setLoading(false);
    }
  };

  //==================== فقط در حالت ویرایش اطلاعات را بارگذاری کن ====================
  useEffect(() => {
    if (isEditMode) {
      void getEditModeData();
    }
  }, [isEditMode]);

  // ==================== هر بار که plateParts تغییر کرد → پلاک کامل را بساز ====================
  useEffect(() => {
    const newPelak =
      plateParts.partOne +
      plateParts.partTwo +
      "-" +
      plateParts.partThree +
      "-" +
      plateParts.partFour +
      plateParts.partFive +
      plateParts.partSix +
      "-" +
      plateParts.partSeven +
      plateParts.partEight;

    setSendData((prev) => ({ ...prev, pelak: newPelak }));
  }, [plateParts]);

  // ==================== بستن دراپ‌دان حرف وقتی کلیک بیرون شد ====================
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openTag &&
        tagBoxRef.current &&
        !tagBoxRef.current.contains(event.target)
      ) {
        setOpenTag(false);
        setFilterText("");
        setSelectedTagIndex(-1);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openTag]);

  //==================== اسکرول خودکار به آیتم انتخاب شده در لیست حروف ====================
  useEffect(() => {
    if (openTag && selectedTagIndex >= 0 && tagListRef.current) {
      const item = tagListRef.current.children[selectedTagIndex];
      item?.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
  }, [selectedTagIndex, openTag]);

  // ==================== ساخت FormData برای ارسال به سرور ====================
  const formDataDriver = () => {
    const formData = new FormData();
    if (isEditMode) formData.append("id", driverId);

    formData.append("driver_name", sendData.driver_name || "");
    formData.append("car_name", sendData.car_name || "");
    formData.append("pelak", sendData.pelak || "");
    formData.append("mobile", sendData.mobile || "");
    formData.append("register_date", sendData.register_date || "");

    // فقط اگر فایل جدید آپلود شده باشد ارسال کن
    formData.append(
      "car_pelak_image",
      sendData.car_pelak_image instanceof File ? sendData.car_pelak_image : ""
    );
    formData.append(
      "driver_image",
      sendData.driver_image instanceof File ? sendData.driver_image : ""
    );

    return formData;
  };

  // ==================== ارسال فرم (ثبت یا ویرایش) ====================
  const handleSubmit = async () => {
    try {
      const request = _axios.post(
        prefixUrl() + "/cheeka/driver/index.php",
        formDataDriver()
      );

      toast.promise(request, { pending: "در حال ثبت راننده..." });

      const response = await request;
      if (response.data.status) {
        toast.success(response.data.message);
        if (isFromOrder) {
          navigateTo("/add-edit-order", {
            state: {
              newCar: {
                id_car: response.data.data.id,
                car_name: response.data.data.car_name,
                pelak: response.data.data.pelak,
                driver_mobile: response.data.data.mobile,
              },
            },
            replace: true,
          });
        } else {
          navigateTo(-1);
        }
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("خطا در ارتباط با سرور");
    }
  };

  // ==================== اعتبارسنجی فرم قبل از ارسال ====================
  const validateForm = () => {
    if (!sendData.car_name?.trim()) {
      toast.error("نام ماشین اجباری است");
      return false;
    }
    if (!sendData.driver_name?.trim()) {
      toast.error("نام و نام خانوادگی راننده اجباری است");
      return false;
    }
    if (sendData.mobile && !UtilsFunctions.validateMobile(sendData.mobile)) {
      toast.error("شماره تماس معتبر نیست");
      return false;
    }

    // بررسی کامل بودن تمام ۸ بخش پلاک
    const isPlateComplete =
      plateParts.partOne &&
      plateParts.partTwo &&
      plateParts.partThree &&
      plateParts.partFour &&
      plateParts.partFive &&
      plateParts.partSix &&
      plateParts.partSeven &&
      plateParts.partEight;

    if (!isPlateComplete) {
      toast.error("پلاک اجباری است");
      return false;
    }

    return true;
  };

  // ==================== مدیریت ورودی‌های عددی پلاک (فقط یک رقم) ====================
  const inputChanger = (value, name, index) => {
    const cleaned = value.replace(/\D/g, "").slice(0, 1);
    setPlateParts((prev) => ({ ...prev, [name]: cleaned }));

    if (cleaned && index < 8) {
      const nextInput = document.getElementById(`input-${index + 1}`);
      nextInput?.focus();

      if (index + 1 === 3) {
        setOpenTag(true);
        setSelectedTagIndex(0);
      }
    }
  };

  // ==================== مدیریت کلید Backspace برای جابجایی بین فیلدها ====================
  const handleBackspace = (e, name, index) => {
    if (e.key !== "Backspace") return;

    const value = e.target.value;
    if (value) {
      setPlateParts((prev) => ({ ...prev, [name]: "" }));
    } else if (index > 1) {
      const prevInput = document.getElementById(`input-${index - 1}`);
      prevInput?.focus();
      prevInput?.select();

      if (index === 4) {
        setOpenTag(true);
        setFilterText("");
        setSelectedTagIndex(0);
      }
    }
  };

  // ==================== کیبورد ناوبری در دراپ‌دان حروف ====================
  const handleTagKeyDown = (e) => {
    if (!openTag) return;

    if (e.key === "Backspace" && !filterText && plateParts.partThree) {
      setPlateParts((prev) => ({ ...prev, partThree: "" }));
      setOpenTag(false);
      document.getElementById("input-2")?.focus();
      return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setSelectedTagIndex((prev) =>
        prev < filteredTags.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setSelectedTagIndex((prev) =>
        prev <= 0 ? filteredTags.length - 1 : prev - 1
      );
    } else if (e.key === "Enter" && selectedTagIndex >= 0) {
      e.preventDefault();
      const selected = filteredTags[selectedTagIndex];
      setPlateParts((prev) => ({ ...prev, partThree: selected.value }));
      setOpenTag(false);
      setFilterText("");
      setSelectedTagIndex(-1);
      document.getElementById("input-4")?.focus();
    } else if (e.key === "Escape") {
      setOpenTag(false);
      setFilterText("");
      setSelectedTagIndex(-1);
    }
  };

  // ==================== رندر نهایی ====================
  return loading ? (
    <Loader />
  ) : (
    <section className="add__edit__driver">
      {/* عنوان صفحه */}
      <div className="content__section">
        <LinedTitle title="مشخصات راننده" />

        <div className="grid__section">
          {/* فیلدهای اصلی */}
          <DynaInput
            label="نام ماشین *"
            name="car_name"
            className="solid-dyna-input"
            placeholder=" نام ماشین را وارد کنید"
            value={sendData?.car_name}
            type="text"
            setDataFromComponent={(data) =>
              setSendData({ ...sendData, ...data })
            }
          />
          <DynaInput
            label="نام و نام خانوادگی راننده *"
            name="driver_name"
            className="solid-dyna-input"
            placeholder=" نام و نام خانوادگی راننده را وارد کنید"
            value={sendData?.driver_name}
            type="text"
            setDataFromComponent={(data) =>
              setSendData({ ...sendData, ...data })
            }
          />

          {/* آپلود تصاویر */}
          <DynaInputFile
            label="تصویر پلاک"
            name="car_pelak_image"
            sendData={sendData}
            setSendData={setSendData}
          />
          <DynaInputFile
            label="تصویر راننده"
            name="driver_image"
            sendData={sendData}
            setSendData={setSendData}
          />

          {/* تاریخ ثبت نام (در ویرایش غیرفعال) */}
          <DynaDatePicker
            label="تاریخ ثبت نام"
            name="register_date"
            className="solid-dyna-input"
            value={sendData?.register_date}
            setDataFromComponent={(data) =>
              setSendData({ ...sendData, register_date: data?.register_date })
            }
            disabled={isEditMode}
          />

          <DynaInput
            label="شماره تماس راننده"
            name="mobile"
            className="solid-dyna-input"
            placeholder="شماره تماس راننده را وارد کنید"
            value={sendData?.mobile}
            type="number"
            setDataFromComponent={(data) =>
              setSendData({ ...sendData, ...data })
            }
          />

          {/* ==================== بخش طراحی پلاک ایران ==================== */}
          <div className="car-tag">
            <p className="tag-lable">پلاک / مولفه * :</p>
            <ul className="tag-number">
              <li>
                <div className="has-iran">
                  <IranIcon />
                </div>
                <input
                  value={plateParts.partEight}
                  type="text"
                  inputMode="numeric"
                  id="input-8"
                  maxLength={1}
                  onChange={(e) => inputChanger(e.target.value, "partEight", 8)}
                  onKeyDown={(e) => handleBackspace(e, "partEight", 8)}
                />
                <input
                  value={plateParts.partSeven}
                  type="text"
                  inputMode="numeric"
                  id="input-7"
                  maxLength={1}
                  onChange={(e) => inputChanger(e.target.value, "partSeven", 7)}
                  onKeyDown={(e) => handleBackspace(e, "partSeven", 7)}
                />
              </li>
              <li>
                <input
                  value={plateParts.partSix}
                  type="text"
                  inputMode="numeric"
                  id="input-6"
                  maxLength={1}
                  onChange={(e) => inputChanger(e.target.value, "partSix", 6)}
                  onKeyDown={(e) => handleBackspace(e, "partSix", 6)}
                />
                <input
                  value={plateParts.partFive}
                  type="text"
                  inputMode="numeric"
                  id="input-5"
                  maxLength={1}
                  onChange={(e) => inputChanger(e.target.value, "partFive", 5)}
                  onKeyDown={(e) => handleBackspace(e, "partFive", 5)}
                />
                <input
                  value={plateParts.partFour}
                  type="text"
                  inputMode="numeric"
                  id="input-4"
                  maxLength={1}
                  onChange={(e) => inputChanger(e.target.value, "partFour", 4)}
                  onKeyDown={(e) => handleBackspace(e, "partFour", 4)}
                />
              </li>
              <li
                className={`tag-box ${openTag ? "open-tag" : ""}`}
                ref={tagBoxRef}
              >
                <input
                  ref={tagInputRef}
                  value={openTag ? filterText : plateParts.partThree}
                  id="input-3"
                  onClick={() => {
                    setOpenTag(true);
                    setSelectedTagIndex(0);
                  }}
                  onChange={(e) => {
                    setFilterText(e.target.value);
                    setSelectedTagIndex(0);
                  }}
                  onKeyDown={handleTagKeyDown}
                  placeholder="حرف"
                />
                <ArrowIcon />
                <div className="plate-list" ref={tagListRef}>
                  {filteredTags.map((item, index) => (
                    <div
                      key={item.value}
                      className={`current-tag ${
                        selectedTagIndex === index ? "selected" : ""
                      }`}
                      onClick={() => {
                        setPlateParts((prev) => ({
                          ...prev,
                          partThree: item.value,
                        }));
                        setOpenTag(false);
                        setFilterText("");
                        document.getElementById("input-4")?.focus();
                      }}
                    >
                      <p>{item.label}</p>
                    </div>
                  ))}
                </div>
              </li>
              <li>
                <input
                  value={plateParts.partTwo}
                  type="text"
                  inputMode="numeric"
                  id="input-2"
                  maxLength={1}
                  onChange={(e) => inputChanger(e.target.value, "partTwo", 2)}
                  onKeyDown={(e) => handleBackspace(e, "partTwo", 2)}
                />
                <input
                  value={plateParts.partOne}
                  type="text"
                  inputMode="numeric"
                  id="input-1"
                  maxLength={1}
                  onChange={(e) => inputChanger(e.target.value, "partOne", 1)}
                  onKeyDown={(e) => handleBackspace(e, "partOne", 1)}
                />
              </li>
              <IranTagSVG />
            </ul>
          </div>
        </div>
      </div>

      <div className="bottom__section">
        <div className="action__buttons">
          <button onClick={() => navigateTo(-1)} className="cancel__button">
            انصراف
          </button>
          <button
            onClick={() => validateForm() && handleSubmit()}
            className="submit__button"
          >
            {isEditMode ? "ویرایش" : "ثبت"}
          </button>
        </div>
      </div>
    </section>
  );
};

export default AddEditDriver;
